import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createVesselInstallation = ({
  id = createUuid(),
  vesselId,
  tenant,
  status = "active",
  authMode = "transitional-firebase-project",
  createdAt = nowIso(),
  updatedAt = createdAt,
  lastProvisionedAt,
}) => {
  assertString(id, "vesselInstallation.id");
  assertString(vesselId, "vesselInstallation.vesselId");
  assertString(tenant, "vesselInstallation.tenant");
  assertString(status, "vesselInstallation.status");
  assertString(authMode, "vesselInstallation.authMode");

  return {
    id,
    vesselId,
    tenant,
    status,
    authMode,
    createdAt,
    updatedAt,
    lastProvisionedAt,
  };
};

